import React, { useState, useEffect } from 'react';
import { Text, Button } from '@radix-ui/themes';
import caseStudy from "../../../assets/images/caseStudy.png";

interface CsVideoChatRequestProps {
  name: string;
  onYes: () => void;
  onNo: () => void;
  activityName?: string;
}

const CsVideoChatRequest: React.FC<CsVideoChatRequestProps> = ({ name, onYes, onNo, activityName }) => {
  const [iconImage, setIconImage] = useState(caseStudy);

  useEffect(() => {
    setIconImage(getIconForActivity(activityName));
  }, [activityName]);

  // Placeholder for getIconForActivity (implement based on your requirements)
  const getIconForActivity = (activity: string): string => {
    // Replace with actual logic to return the appropriate icon path based on activityName
    return '/assets/caseStudy.png'; // Default fallback
  };

  return (
    <div className="flex flex-1 flex-col items-center justify-center py-[2vh]">
      <img
        src={iconImage}
        alt="Activity Icon"
        className="h-[10vh] w-[25vw] object-contain"
      />
      <Text className="text-white py-4 text-center font-[Lato-Regular] text-base w-[60vw] mb-4">
        {`${name} requesting for video chat. Do you approve?`}
      </Text>
      <div className="flex flex-row items-center">
        <Button
          onClick={onYes}
          className="bg-blue-600 hover:bg-blue-700 text-white font-[Lato-Regular] text-sm px-6 py-2 mx-2 rounded-[20px] shadow-sm"
        >
          Yes
        </Button>
        <Button
          onClick={onNo}
          className="bg-blue-600 hover:bg-blue-700 text-white font-[Lato-Regular] text-sm px-6 py-2 mx-2 rounded-[20px] shadow-sm"
        >
          No
        </Button>
      </div>
    </div>
  );
};

export default CsVideoChatRequest;